<template>
    <div class="editor_panel" :style="colors">
        <div class="editor_panel-nav">
            <div
                class="editor_panel-nav-item active"
                @click="openTemplates"
            >
                <inline-svg
                    alt="template"
                    :src="template_icon"
                />
                <p>{{ $t('editorTemplatesTitle') }}</p>
            </div>
            <div
                class="editor_panel-nav-item"
                @click="openPlaceholders"
            >
                <inline-svg
                    alt="placeholder"
                    :src="placeholder_icon"
                />
                <!-- <p>Place<br>holders</p> -->
                <p>{{ $t('editorPlaceholdersTitle') }}</p>
            </div>
            <Lang />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import template_icon from '@/assets/icons/panel_icons/template.svg';
    import placeholder_icon from '@/assets/icons/placeholders.svg';
    import Lang from '@/components/Global/Language.vue';

    export default {
        data() {
            return {
                template_icon,
                placeholder_icon
            }
        },
        methods: {
            openTemplates() {
                this.$router.push({ name: 'templates'});
            },
            openPlaceholders() {
                this.$router.push({ name: 'placeholders'})
            }
        },
        computed: {
            ...mapGetters([
                'getSessionDetails'
            ]),
            colors() {
                return {
                    '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
                }
            }
        },
        components: {
            Lang
        }
    }
</script>

<style lang="scss" scoped>
    .editor_panel-nav {
        &-item {
            &:hover,
            &.active {
                color: var(--primary-color);

                svg {
                    fill: var(--primary-color);
                }
            }
        }
    }
</style>